import { createFileRoute, redirect } from '@tanstack/react-router';
import { useState } from 'react';
import { AddDayCodesDialog } from '@/features/sync/dayCodes/AddDayCodesDialog';
import { ImportAttendanceDialog } from '@/features/sync/import/ImportAttendanceDialog';
import { SheetTabPage } from '@/features/sync/SheetTabPage';
import { SHEET_TABS } from '@/features/sync/sheetTabConfigs';
import { legacyCompareRedirect, syncSearchSchema } from '@/features/sync/syncSearch';

export const Route = createFileRoute('/_authenticated/attendance/sheet')({
  validateSearch: syncSearchSchema,
  beforeLoad: ({ search }) => {
    if (legacyCompareRedirect(search, '/attendance/sheet-review')) throw redirect({ to: '/attendance/sheet-review', search: { f: search.f, s: search.s }, replace: true });
  },
  component: function AttendanceSheet() {
    const navigate = Route.useNavigate();
    const [importing, setImporting] = useState(false);
    const [addingDayCodes, setAddingDayCodes] = useState(false);
    return (
      <>
        <SheetTabPage config={SHEET_TABS.attendance} onImport={() => setImporting(true)} onAddDayCodes={() => setAddingDayCodes(true)} onScanned={() => void navigate({ to: '/attendance/sheet-review' })} />
        <ImportAttendanceDialog open={importing} onOpenChange={setImporting} onOpenSheet={() => undefined} />
        <AddDayCodesDialog open={addingDayCodes} onOpenChange={setAddingDayCodes} onOpenReview={() => void navigate({ to: '/attendance/sheet-review' })} />
      </>
    );
  },
});
